var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.formInfo,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "16px" },
                  attrs: { label: "作品名称：", prop: "title" },
                },
                [
                  _c("el-input", {
                    staticStyle: { "margin-left": "-100px" },
                    model: {
                      value: _vm.formInfo.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInfo, "title", $$v)
                      },
                      expression: "formInfo.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "作品简介：", prop: "description" } },
                [
                  _c("el-input", {
                    staticStyle: { "margin-left": "-100px" },
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.formInfo.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInfo, "description", $$v)
                      },
                      expression: "formInfo.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.saveFile } },
                    [_vm._v("提交")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }